/** @jsxImportSource @emotion/react */
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import { css, jsx } from '@emotion/react';
import { colors } from '@atlaskit/theme';
import { gridSize } from '@atlaskit/theme/constants';
import { e300 } from '@atlaskit/theme/elevation';
import queryString from 'query-string';
import Skeleton from 'react-loading-skeleton';
import Page from '@atlaskit/page';
import { InvoiceRender } from '@accountingbox/invoice-templates';
import InvoicePreviewSkeleton from './components/InvoicePreviewSkeleton';
import useTimeout from '../../hooks/useTimeout';
import { DateTime } from 'luxon';

// const baseUrl = process.env.NODE_ENV === 'production' ? 'https://invoice-renderer.accountingbox.nl' : 'http://localhost:3005';
// const baseUrl = 'https://invoice-renderer.accountingbox.nl';


export default function SaleInvoicePreview({ invoice: invoiceInput, invoiceSettings = {}, scale = 0.8 }) {

  const invoice = {...invoiceInput};

  if(invoice) {
    if(!invoice.invoiceNumber) {
      invoice.invoiceNumber = '..............'
    }
    if(!invoice.invoiceDate) {
      invoice.invoiceDate = invoice.startDate || new Date().toISOString();
      invoice.paymentTerm = invoice.paymentTerm || (invoice.customer && invoice.customer.paymentTerm) || 14;
      invoice.dueDate = DateTime.fromISO(invoice.invoiceDate).plus({ days: invoice.paymentTerm }).toISODate();
    }
  }

  const [loading, setLoading] = useState(true);
  const [height, setHeight] = useState(793.70)
  useTimeout(()=> setLoading(false), 200);

  const onChangeHeight = useCallback((newHeight)=> {
    setHeight(newHeight)
  },[setHeight])

  const wrapperProps = useMemo(()=>({
    onChangeHeight
  }),[onChangeHeight])

  // const [iframeLoaded, setIframeLoaded] = useState(false);
  // const url = useMemo(() => {
  //   if (!invoice.id && !invoice.isNew) return null;
  //   const {events, ...invoiceData} = invoice;
  //   const query = queryString.stringify({
  //     invoice: JSON.stringify(invoiceData),
  //     invoiceSettings: JSON.stringify(invoiceSettings),
  //   });
  //   return `${baseUrl}?${query}`; // FIXME potential issue that url will be to long (LB might not handle it in production?)
  // }, [invoice.id, invoice.isNew]);
  //
  // const iframe = useCallback(
  //   (node) => {
  //     if (node && node.contentWindow && iframeLoaded) {
  //       try {
  //         node.contentWindow.postMessage({ invoice, invoiceSettings }, url);
  //       }catch (e) {
  //         console.error(e);
  //       }
  //     }
  //   },
  //   [invoice, invoiceSettings, iframeLoaded, url]
  // );

  return (
    <div
      css={css`
        height: 100%;
        box-sizing: border-box;
        //overflow-y: scroll;
        //overflow-x: auto;
        display: flex;
        justify-content: center;
        background-color: ${colors.N10};
        padding: ${gridSize() * 5}px;
      `}
    >
      <div
        css={css`
                // margin: ${gridSize() * 4}px 0px;
                width: ${21 * scale}cm;
                height: ${height * scale}px;
             `}
      >
          <div css={css`
              background: white;
              width: 21cm;
              transform: scale(${scale});
              transform-origin: 0 0;
              min-height: 29.7cm;
              box-sizing: content-box;
              ${e300()}
            `}>
            {(loading || !invoice || !invoiceSettings) ? <InvoicePreviewSkeleton/>:
            <InvoiceRender invoice={invoice} invoiceSettings={invoiceSettings} wrapperProps={wrapperProps}/> }
          </div>
          {/*{!iframeLoaded && <InvoicePreviewSkeleton/>}*/}
          {/*<iframe*/}
          {/*  title="invoice-renderer"*/}
          {/*  css={css`*/}
          {/*    background: white;*/}
          {/*    width: 21cm;*/}
          {/*    height: 29.7cm;*/}
          {/*    box-sizing: content-box;*/}
          {/*    ${e300()}*/}
          {/*  `}*/}
          {/*  src={url}*/}
          {/*  ref={iframe}*/}
          {/*  onLoad={() => setIframeLoaded(true)}*/}
          {/*/>*/}
      </div>
    </div>
  );
}
